/**
 * Csv Schema of PosicaoMotorista
 * @author Simpli CLI generator
 */
import {Helper, Schema, FieldSet} from 'simpli-web-sdk'
import {PosicaoMotorista} from '@/model/resource/PosicaoMotorista'

/* TODO: review generated schema */
export class CsvPosicaoMotoristaSchema extends Schema {
  readonly name = 'CsvPosicaoMotorista'

  readonly fieldSet: FieldSet<PosicaoMotorista> = {
    idPosicaoPk: schema => schema.model.idPosicaoPk,
    carga: schema => schema.model.carga?.$id ?? null,
    motorista: schema => schema.model.motorista?.$id ?? null,
    latitude: schema => schema.model.latitude,
    longitude: schema => schema.model.longitude,
    data: schema => Helper.datetime(schema.model.data),
    distanciaParaDestinoEmMetros: schema =>
      schema.model.distanciaParaDestinoEmMetros,
    duracaoParaDestinoEmSegundos: schema =>
      schema.model.duracaoParaDestinoEmSegundos,
  }
}
